import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

import { VersionsService} from './versions.service';
import { DataCacheService } from '../../shared/services/storage/data-cache.service';
import { versionsURLs, headerName } from './cacheable-data';


@Injectable({
  providedIn: 'root'
})
export class VersionsInterceptorService implements HttpInterceptor {
  private currentVersions: {} = {};
  
  constructor(
    private readonly versions: VersionsService,
    private readonly cachedData: DataCacheService
  ) {
    for (let dataType in versionsURLs) {
      this.currentVersions[dataType] = this.versions.getSavedVersion(dataType);
    }
    //console.log('data versions on init (from localStorage):', this.currentVersions);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(!req.url.includes('assets/i18n') || window.navigator.onLine){
      return (this.cancelRequest(req)) ? from(this.getCachedData(req, next)) : from(this.handleHeaders(req, next));
    }
    //else console.log("getting translations from local i18");
  }


  private getCachedData(req: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    let cachedData;

    for (let dataType in versionsURLs) {
      if (req.url.includes(versionsURLs[dataType])) {
        cachedData = this.cachedData.loadData(dataType);    
        //console.log(`retrieved cached data for ${dataType}:`, cachedData);
      }
    }

    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        event['body'] = cachedData;
        return event;
      })
    ).toPromise();
  }

  private cancelRequest(req: HttpRequest<any>) {
    let cancel = false;

    for (let dataType in versionsURLs) {
      if (req.url.includes(versionsURLs[dataType]) && this.cachedData.loadData(dataType)) {
        cancel = (this.versions.getSavedVersion(dataType) > 0) ? true : false; 
      }
    }
    //console.log('req url ->', req.url, 'canceled ->', cancel);
    return cancel;
  }

  private handleHeaders(req: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {   
        // response
        if (event instanceof HttpResponse) {
          const versionsHeader = JSON.parse(event.headers.get(headerName));      

          if (versionsHeader) {
            this.currentVersions = { ...versionsHeader };
            //console.log('current versions in header:', this.currentVersions);
            // save data version for current request
            for (let dataType in this.currentVersions) {
              this.versions.saveVersion(dataType, this.currentVersions[dataType]);
            }
            // save cache data 
            for (let dataType in versionsURLs) {
              if (event.url.includes(versionsURLs[dataType])) {
                this.cachedData.saveData(dataType, event.body);
              }
            }    
          }       
        } 
        return event;
      })
    ).toPromise();
  }
}